/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AdSpendInput
 */
export interface AdSpendInput {
  /**
   *
   * @type {string}
   * @memberof AdSpendInput
   */
  adSpendId?: string | null;
  /**
   *
   * @type {LocalDate}
   * @memberof AdSpendInput
   */
  spendDate: LocalDate;
  /**
   *
   * @type {number}
   * @memberof AdSpendInput
   */
  googleAdsSpendCad: number;
  /**
   *
   * @type {number}
   * @memberof AdSpendInput
   */
  microsoftAdsSpendCad: number;
}

/**
 * Check if a given object implements the AdSpendInput interface.
 */
export function instanceOfAdSpendInput(value: object): value is AdSpendInput {
  if (!("spendDate" in value) || value["spendDate"] === undefined) return false;
  if (
    !("googleAdsSpendCad" in value) ||
    value["googleAdsSpendCad"] === undefined
  )
    return false;
  if (
    !("microsoftAdsSpendCad" in value) ||
    value["microsoftAdsSpendCad"] === undefined
  )
    return false;
  return true;
}

export function AdSpendInputFromJSON(json: any): AdSpendInput {
  return AdSpendInputFromJSONTyped(json, false);
}

export function AdSpendInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AdSpendInput {
  if (json == null) {
    return json;
  }
  return {
    adSpendId: json["adSpendId"] == null ? undefined : json["adSpendId"],
    spendDate: json["spendDate"],
    googleAdsSpendCad: json["googleAdsSpendCad"],
    microsoftAdsSpendCad: json["microsoftAdsSpendCad"],
  };
}

export function AdSpendInputToJSON(json: any): AdSpendInput {
  return AdSpendInputToJSONTyped(json, false);
}

export function AdSpendInputToJSONTyped(
  value?: AdSpendInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    adSpendId: value["adSpendId"],
    spendDate: value["spendDate"],
    googleAdsSpendCad: value["googleAdsSpendCad"],
    microsoftAdsSpendCad: value["microsoftAdsSpendCad"],
  };
}
